import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  getShipperOrderDetail,
  getShipperOrderDetailData,
  getShipperOrderDetailError,
} from 'redux/modules/shipper-order-detail/selectors';

import { isUploadDocumentsModalOpened } from 'redux/modules/shipper-order-documents/selectors';

import DocumentsModal from 'modules/shipper-order/Documents/DocumentsModal';

import JourneyMap from 'modules/journey/map/Modal';

import {
  detailMounted as queuedDetailMounted,
  detailUnmounted as queuedDetailUnmounted,
} from 'redux/modules/shipper-order-detail/effects';

import {
  DetailContainerStyled,
  WrapperStyled,
  SidebarStyled,
  ContainerStyled,
  ContentStyled,
  SectionStyled,
} from 'modules/detail/styled';

import SidebarQueued from './sections/sidebar-queued';
import ShipperOrderInfo from './sections/shipper-order-info';
import StopsInfo from './sections/stops-info';
import StatusInfo from './sections/status-info';
import Header from './sections/header';
import ErrorSection from './sections/error';
import CancellationReasons from 'modules/cancellation-reasons';
import { IS_TENANT } from 'tenant/config';

const actionCreators = {
  queuedDetailMounted,
  queuedDetailUnmounted,
};

const ShipperOrderDetail = ({
  fetching,
  queuedDetailMounted,
  queuedDetailUnmounted,
  shipperOrder,
  match: {
    params: { id },
  },
  error,
  isUploadDocumentsModalOpened,
}) => {
  useEffect(() => {
    queuedDetailMounted({ id });
    return () => {
      queuedDetailUnmounted();
    };
  }, [queuedDetailMounted, queuedDetailUnmounted, id]);

  return (
    <>
      <DetailContainerStyled>
        {/* tenant dosnt have sidebar log so wrapper takes fullWidth */}
        <WrapperStyled fullWidth={IS_TENANT}>
          <Header />
          {!!error ? (
            <ErrorSection error={error} />
          ) : (
            <ContainerStyled>
              <ContentStyled>
                <SectionStyled flex="0 1 17rem" p="S">
                  <StatusInfo fetching={fetching} />
                </SectionStyled>
                <SectionStyled flex="0 1 20rem" background="grey700" p="S">
                  <ShipperOrderInfo fetching={fetching} />
                </SectionStyled>
                <SectionStyled flex="1" background="grey800" p="S">
                  {/* hide stops info for tenant */}
                  {!IS_TENANT && <StopsInfo fetching={fetching} />}
                </SectionStyled>
              </ContentStyled>
            </ContainerStyled>
          )}
        </WrapperStyled>
        {/* hide sidebar logs for tenant */}
        {!IS_TENANT && (
          <SidebarStyled>
            <SidebarQueued
              fetching={fetching}
              shipperOrderId={(shipperOrder || {}).id}
              shipperOrder={shipperOrder}
            />
          </SidebarStyled>
        )}
      </DetailContainerStyled>

      <JourneyMap />
      <CancellationReasons />

      {isUploadDocumentsModalOpened && <DocumentsModal />}
    </>
  );
};

ShipperOrderDetail.propTypes = {
  opened: PropTypes.bool,
  fetching: PropTypes.bool,
  item: PropTypes.object,
  saveEditCost: PropTypes.func,
  isUploadDocumentsModalOpened: PropTypes.bool,
};

ShipperOrderDetail.defaultProps = {
  error: null,
};

export default connect((state) => {
  const shipperOrderDetail = getShipperOrderDetail(state);

  return {
    shipperOrder: getShipperOrderDetailData(state),
    error: getShipperOrderDetailError(state),
    fetching: shipperOrderDetail.fetching,
    isUploadDocumentsModalOpened: isUploadDocumentsModalOpened(state),
  };
}, actionCreators)(ShipperOrderDetail);
